import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { ReactComponent as BackIcon } from "../../assets/icons/generic/SquareArrow.svg";
import {
  BUTTON,
  CENTER,
  END,
  FIT,
  FULL,
  IMAGE,
  LARGE,
  MEDIUM,
  MENU,
  PILL,
  ROUND,
  SMALL,
  SQUARE,
  START,
} from "../../constants/OptionsConstants";
import CustomInput from "../AuthenticationComponents/CustomInput";
import CustomEditorMenuButton from "./CustomEditorMenuButton";

const CustomEditorImageMenu = ({
  setDisplayOption,
  setActiveElementIndex,
  resultList,
  activeElementIndex,
  handleItemChanges,
}) => {
  const currentImage = resultList.find(
    (item) => item.id === activeElementIndex
  );
  const currentProps = currentImage.content.props.state;

  const [size, setSize] = useState(currentProps?.size);
  const [position, setPosition] = useState(currentProps?.position);
  const [title, setTitle] = useState(currentProps?.title);
  const [src, setSrc] = useState(currentProps?.src);
  const [alt, setAlt] = useState(currentProps?.alt);

  const handleBack = () => {
    setDisplayOption(MENU);
    setActiveElementIndex(null);
  };

  useEffect(() => {
    if (!currentImage || !currentProps) {
      return;
    }

    setSize(currentProps.size);
    setPosition(currentProps.position);
    setTitle(currentProps.title);
    setSrc(currentProps.src);
    setAlt(currentProps.alt);
  }, [currentImage.id]);

  useEffect(() => {
    handleItemChanges(currentImage.id, "size", size);
  }, [size]);

  useEffect(() => {
    handleItemChanges(currentImage.id, "position", position);
  }, [position]);

  useEffect(() => {
    handleItemChanges(currentImage.id, "title", title);
  }, [title]);
  useEffect(() => {
    handleItemChanges(currentImage.id, "src", src);
  }, [src]);
  useEffect(() => {
    handleItemChanges(currentImage.id, "alt", alt);
  }, [alt]);

  return (
    <MenuCard>
      <MenuContent>
        <Line style={{ position: "relative" }}>
          <CloseBtn onClick={() => handleBack()}>
            <BackIcon />
            Back
          </CloseBtn>
          <HeadWrapper>
            <h1>{IMAGE}</h1>
          </HeadWrapper>
        </Line>

        <Group>
          <GroupDescription>Position</GroupDescription>
          <Line>
            <CustomEditorMenuButton
              onClick={() => setPosition(START)}
              selected={position === START}
            >
              Left
            </CustomEditorMenuButton>
            <CustomEditorMenuButton
              onClick={() => setPosition(CENTER)}
              selected={position === CENTER}
            >
              Center
            </CustomEditorMenuButton>
            <CustomEditorMenuButton
              onClick={() => setPosition(END)}
              selected={position === END}
            >
              Right
            </CustomEditorMenuButton>
          </Line>
        </Group>
        <Group>
          <GroupDescription>Size</GroupDescription>
          <Line>
            <CustomEditorMenuButton
              onClick={() => setSize(SMALL)}
              selected={size === SMALL}
            >
              Small
            </CustomEditorMenuButton>
            <CustomEditorMenuButton
              selected={size === MEDIUM}
              onClick={() => setSize(MEDIUM)}
            >
              Medium
            </CustomEditorMenuButton>
            <CustomEditorMenuButton
              selected={size === FULL}
              onClick={() => setSize(FULL)}
            >
              Full
            </CustomEditorMenuButton>
          </Line>
        </Group>
        <Group>
          <GroupDescription>Source</GroupDescription>
          <Line>
            <CustomInput
              placeholder={"Enter the link to your image"}
              value={src}
              onChange={(e) => setSrc(e.currentTarget.value)}
            />
          </Line>
        </Group>
        <Group>
          <GroupDescription>Title</GroupDescription>
          <Line>
            <CustomInput
              placeholder={"Enter a title for your image"}
              value={title}
              onChange={(e) => setTitle(e.currentTarget.value)}
            />
          </Line>
        </Group>
        <Group>
          <GroupDescription>Alt</GroupDescription>
          <Line>
            <CustomInput
              placeholder={"Enter a alternative text for the image"}
              value={alt}
              onChange={(e) => setAlt(e.currentTarget.value)}
            />
          </Line>
        </Group>
      </MenuContent>
    </MenuCard>
  );
};

export default CustomEditorImageMenu;
const MenuCard = styled.div`
  max-width: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  top: 0;
  background: ${lightThemeColors.menuBackground};
  z-index: 1;
  position: relative;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: auto;
  h1 {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 20px;
    font-weight: 700;
    line-height: 37.5px;
  }
  p {
    color: ${lightThemeColors.darkColorFaded30};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border: none;
  background: none;
  cursor: pointer;
  gap: 10px;
  color: ${lightThemeColors.primaryColor};
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  position: absolute;
  top: calc(50% - 11px);
  left: 40;
`;
const Line = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 0 40px;
  width: 100%;
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const MenuContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 20px;
  padding: 40px 0;
`;

const GroupDescription = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${lightThemeColors.inputSubtitleColor};
  padding: 0px 40px;
  padding-top: 10px;
`;
